// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__CUurP","navbar_item":"Navbar_navbar_item__VC19L"};